import Component from './Component';

const path = '#files';
import { ImageIcon as label } from '@/icons';

const description = 'Mes fichiers';

const Page = { Component, path, label, description };
export default Page;
